import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase, objectKeysSnakeCaseToCamelCase } from 'core/utils';
import { IExternalPricesPayload, IExternalPricesResponse } from 'parts/types';
import { pickFirstExternalPricesBlock } from 'parts/utils';

export const getExternalPrices = async (
  payload: IExternalPricesPayload,
  signal?: AbortSignal
): Promise<{ success: boolean; record: IExternalPricesResponse | null }> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/part/external-prices?${getQueryStringToSnakeCase(payload, {
      removeNullValues: true,
    })}`,
    signal
  );

  const success = !!data?.success;
  const firstUomBlock = pickFirstExternalPricesBlock<Record<string, unknown>>(
    data?.external_prices
  );

  if (!firstUomBlock) {
    return { success, record: null };
  }

  return {
    success,
    record: objectKeysSnakeCaseToCamelCase(firstUomBlock) as IExternalPricesResponse,
  };
};
